<script >

export default {
  name:"Aside",
  props: ['user'],
  data(){
    return{
      user:{},
      path:this.$router.path
    }
  },
  created() {
    let userStr = sessionStorage.getItem("user") || "{}";
    this.user = JSON.parse(userStr);
  }
}
</script>

<template>
<div>
  <el-menu

      :default-openeds='["home"]'
      router
      class="el-menu-vertical-demo"
      style="width: 200px; min-height:calc(100vh - 50px)"
  >
    <el-menu-item index="home">
      <template #title>系统首页</template>
    </el-menu-item>
    <el-sub-menu index="1" v-if="user.role === 1">
      <template #title>系统管理</template>
        <el-menu-item index="user">用户管理</el-menu-item>
    </el-sub-menu>
    <el-sub-menu index="2">
      <template #title>活动管理</template>
      <el-menu-item index="apply">活动创建及历史</el-menu-item>
      <el-menu-item index="activityfirststate">活动初审</el-menu-item>
      <el-menu-item index="activitysecondstate">活动再审</el-menu-item>
      <el-menu-item index="totalactivity">活动汇总</el-menu-item>

      <el-menu-item index="Site">场地预约</el-menu-item>

    </el-sub-menu>
    <el-sub-menu index="3">
      <template #title>公告管理</template>
      <el-menu-item index="notice">管理公告</el-menu-item>
    </el-sub-menu>

  </el-menu>
</div>
</template>

<style scoped>

</style>